import { JQElementHelper } from "../../lib/JQElementHelper";
import { AxDropdownInteraction } from "./AxDropdownInteraction";
export class AxDropdownRender {
    constructor(selector, options) {
        this.$parents = $(selector);
        this.options = options;
        this.jqElementHelper = new JQElementHelper();
        this.interaction = new AxDropdownInteraction(options);
    }
    renderRequiredStructure() {
        this.jqElementHelper.iterateSelector(this.$parents, ($e) => {
            const tippy = this.interaction.getTippyInstance($e);
            const $menu = $((tippy === null || tippy === void 0 ? void 0 : tippy.popper) || $e.find('.ax-dropdown__menu'));
            const $label = $e.find('.ax-dropdown__label');
            const menuId = $menu.attr('id');
            let labelId = $label.attr('id');
            if (!labelId) {
                labelId = `label_${menuId}`;
                $label.attr('id', labelId);
            }
            const $trigger = $e.find('.ax-dropdown__trigger');
            const triggerId = $trigger.attr('id') || `trigger_${menuId}`;
            $trigger.attr('id', triggerId);
            $menu.attr('role', 'listbox')
                .attr('tabindex', -1)
                .attr('aria-labelledby', labelId);
            $trigger.attr('tabindex', 0);
            const ariaLabel = $e.attr('aria-label');
            if (!ariaLabel && $label.length > 0) {
                $e.attr('aria-labelledby', labelId);
            }
            else if (!ariaLabel) {
                $e.attr('aria-label', $e.find('.ax-dropdown__selection').text().trim());
            }
            $e
                .attr('aria-controls', menuId)
                .attr('role', 'combobox')
                // If there is a wrapper for several ax-dropdown Tippy is inserting aria-expanded on it
                .parent()
                .removeAttr('aria-expanded');
        });
    }
}
